export const cardDesignInitialValues = {
  x: 30,
  y: 30,
  xWithTextWidth: 30,
  shadowX: 2,
  shadowY: 2,
  show: false,
  fontSize: 16,
  alignment: 1,
  disclaimer: 0,
  shadowBlur: 4,
  content: "test",
  color: "#000000",
  hasShadow: false,
  borderThickness: 0,
  borderColor: "#000000",
  shadowColor: "#000000",
};
